import { AlarmLog, Alarm, AlarmState } from "../services/types/fleet-alarms-service.types";
import { BaseModel } from "./base-model";
import { FleetAlarm, VesselRank } from "./types/voy-fleet-alarm-model.types";

let VoyFleetAlarmModel: VoyFleetAlarmModelBase|null = null;

function setVoyFleetAlarmModel(model: VoyFleetAlarmModelBase)
{
    VoyFleetAlarmModel = model;
}

export abstract class VoyFleetAlarmModelBase extends BaseModel {
    public abstract get vesselRanks(): Map<number, VesselRank>
    public abstract getVesselAlarms(imo: number, excludeStates?: AlarmState[], fromDate?:string, toDate?:string): Promise<FleetAlarm[] | undefined>
    public abstract getVesselAlarmsBasicInfo(imo: number): FleetAlarm[]
    public abstract getVesselAlarmByID(alarmId: number): Promise<FleetAlarm>
    public abstract updateAlarm(alarmId: number, alarmState: AlarmState, reason: string, alarmNote?: string): Promise<FleetAlarm|null> 
    public abstract updateWeatherAlarm(alarmId: number, alarmState: AlarmState, reason: string, alarmNote?: string): Promise<any> 
    public abstract getCompanyWeatherLimits(): Promise<any>
    public abstract getCustomWeatherLimits(): Promise<any>
    public abstract getCustomWeatherLimitsByIMO(imoList: number[]): Promise<any>
    public abstract getCompanyWeatherLimitsHistory(isCustom:boolean):Promise<any>
    public abstract setCompanyWeatherLimits(data: any): Promise<any>
    public abstract setCustomWeatherLimits(data: any): Promise<any>
    public abstract get getWeatherAlarms(): Alarm[]
    public abstract get getWeatherAlarmsForNotificationSender(): FleetAlarm[]
    public abstract _fetchAlarmsForNotificationSender(): Promise<void>
    public abstract deleteCustomWeatherLimits(imo: number): Promise<any>
}

export { VoyFleetAlarmModel, setVoyFleetAlarmModel };
